import { c as _c } from "react/compiler-runtime";
import { FlexColumn, SpaceBetween, TextBody } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { Button } from "../../../components/Button";
import { EMBEDDED_WALLET_CONNECTOR_ID } from "../../../lib/wagmi";
import { useAccount } from "../../../polychain/hooks";
import { useErrors } from "../../hooks/useErrors";
import { ConnectEmbeddedWallet } from "../ConnectEmbeddedWallet";
import { WalletPaymentStep } from "../WalletPaymentStep";
export const CheckoutPaymentStep = t0 => {
  const $ = _c(19);
  const {
    cardDisabled,
    paymentMethod,
    onChangePaymentMethod,
    timeline,
    setPaymentMethod,
    currencySelector,
    hidePaymentMethodOptions
  } = t0;
  const t = useTranslations("wallet.CheckoutPaymentStep");
  const isWalletEmbeddedSelected = paymentMethod === `wallet-${EMBEDDED_WALLET_CONNECTOR_ID}`;
  const {
    connectorId
  } = useAccount();
  const isEmbeddedWalletConnected = connectorId === EMBEDDED_WALLET_CONNECTOR_ID;
  const {
    clearErrors
  } = useErrors();
  let t1;
  if ($[0] !== clearErrors || $[1] !== onChangePaymentMethod) {
    t1 = () => {
      onChangePaymentMethod?.();
      clearErrors();
    };
    $[0] = clearErrors;
    $[1] = onChangePaymentMethod;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleChangePaymentMethod = t1;
  if (isWalletEmbeddedSelected && !isEmbeddedWalletConnected) {
    const t2 = onChangePaymentMethod ? handleChangePaymentMethod : undefined;
    let t3;
    if ($[3] !== t2) {
      t3 = <FlexColumn className="w-full min-w-0"><ConnectEmbeddedWallet onChangePaymentMethod={t2} /></FlexColumn>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t2;
  if ($[5] !== handleChangePaymentMethod || $[6] !== onChangePaymentMethod || $[7] !== t) {
    t2 = onChangePaymentMethod && <SpaceBetween className="mb-4 items-center"><TextBody className="uppercase" color="text-secondary" size="xs" weight="semibold">{t("payment")}</TextBody><Button onClick={handleChangePaymentMethod} size="sm" variant="secondary">{t("change")}</Button></SpaceBetween>;
    $[5] = handleChangePaymentMethod;
    $[6] = onChangePaymentMethod;
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== cardDisabled || $[10] !== currencySelector || $[11] !== hidePaymentMethodOptions || $[12] !== paymentMethod || $[13] !== setPaymentMethod || $[14] !== timeline) {
    t3 = <FlexColumn className="w-full min-w-0"><WalletPaymentStep cardDisabled={cardDisabled} currencySelector={currencySelector} hidePaymentMethodOptions={hidePaymentMethodOptions} paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod} timeline={timeline} /></FlexColumn>;
    $[9] = cardDisabled;
    $[10] = currencySelector;
    $[11] = hidePaymentMethodOptions;
    $[12] = paymentMethod;
    $[13] = setPaymentMethod;
    $[14] = timeline;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t2 || $[17] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
};